import gsap, { Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Ease } from '../_app/cuchillo/utils/Ease';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';

export class ScrollItem__BlockDefault extends VScroll_Item {
    // number;
    // title;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.setAnimations();

        this.onShow = () => {
            this.showFunction();
        };
        this.onHide = () => {
            this.hideFunction();
        };
        this.onMove = () => {
            this.moveFunction();
        };
    }

    setAnimations() {
        let title = GetBy.selector('.__title p', this.item)[0];
        if (!title) title = GetBy.class('__title', this.item)[0];
        if (title) {
            new SplitText(title, {
                type: 'lines',
                linesClass: 'line-parent'
            });
            this.title = new SplitText(title, {
                type: 'words'
            }).words;
            gsap.set(this.title, { y: '100%' });
        }

        let texts = GetBy.selector('.__text p', this.item);
        if (texts.length > 0) {
            this.texts = new SplitText(texts, {
                type: 'lines'
            }).lines;
            new SplitText(texts, {
                type: 'lines',
                linesClass: 'line-parent'
            });
            gsap.set(this.texts, { y: '100%' });
        }

        let img = GetBy.selector('.__img', this.item);
        if (img.length > 0) {
            this.img = img;
            gsap.set(this.img, { opacity: 0 });
        }

        let numbers = GetBy.selector('.__number', this.item);
        if (numbers.length > 0) {
            this.numbers = numbers;
            gsap.set(this.numbers, { opacity: 0 });
        }
    }

    showFunction() {
        let delay = 0;

        if (this.img) {
            gsap.to(this.img, {
                opacity: 1,
                duration: 1.5,
                ease: Power2.easeOut
            });
        }

        if (this.numbers) {
            for (let i = 0; i < this.numbers.length; i++) {
                const num = this.numbers[i];

                let initialValue = { val: 0 };
                let finalValue = parseFloat(num.textContent.replace(/,/g, '')); // Agafa el número real
                num.innerHTML = 0;

                let digitCount = finalValue.toString().length; // Comptem les xifres del número
                let duration = Math.min(Math.max(digitCount * 0.3, 1), 5); // Min 1s, max 5s

                gsap.to(num, {
                    opacity: 1,
                    duration: .2,
                    delay: delay + i * 0.2
                });

                gsap.to(initialValue, {
                    val: finalValue,
                    duration,
                    delay: delay + i * 0.2,
                    ease: Ease.EASE_CUCHILLO_IN_OUT,
                    snap: 1,
                    onUpdate: function () {
                        num.innerHTML = Math.round(initialValue.val).toLocaleString();
                    }
                });
            }
        }

        if (this.title) {
            for (let i = 0; i < this.title.length; i++) {
                const title = this.title[i];
                gsap.to(title, {
                    y: 0,
                    delay: delay + i * .1,
                    duration: 1.5,
                    ease: Ease.EASE_CUCHILLO_IN_OUT
                });
            }

            delay += .4;
        }

        if (this.texts) {
            for (let i = 0; i < this.texts.length; i++) {
                const text = this.texts[i];
                gsap.to(text, {
                    y: 0,
                    delay: delay + i * .15,
                    duration: 1.5,
                    ease: Ease.EASE_CUCHILLO_IN_OUT
                });
            }
        }
    }

    hideFunction() { }

    moveFunction() { }
}

Scroll._registerClass('BlockDefault', ScrollItem__BlockDefault);
